import React, { useRef, useEffect } from 'react';
import Header from 'modules/Shared/components/Header/Header';
import Footer from 'modules/Shared/components/Footer/Footer';
import Contact from 'modules/MainModule/components/Contact/Contact';
import StartNow from 'modules/Shared/components/StartNow/StartNow';
import { colorBackgroundBrightness } from 'data/common.data';
import '../IndustryType.scss';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const TMC = (props: any) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    });
    const headerBg: string = '/images/backgrounds/ALEG-Image-TravelManagement_Header.jpg'
    const styleData = { backgroundImage: `linear-gradient(${colorBackgroundBrightness}, ${colorBackgroundBrightness}), url(${headerBg})` };
    const contentData: string = 'Turn your client\'s employees into avid travel fans, with AirLegit\'s integrated platform proactively remediates disruptions.';
    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>AirLegit Tools for Travel Management Companies</title>
                    <meta name='description' content={contentData} />
                </Helmet>
            </HelmetProvider>
            <Header />
            <div className='page-min-height industry-type-data-container'>
                <div className='header-container container-side-padding container-content-padding' style={styleData}>
                    <div className='container-small-width'>
                        <div className='container no-padding'>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <h1>
                                        Travel Management Companies
                                    </h1>
                                    <p className=''>
                                        Turn your client's employees into avid fans of travel, enjoying company's provided tools as AirLegit's integrated platform proactively remediates disruptions.
                                    </p>
                                </div>
                                <div className='col-md-6'>
                                    <div className='logo-wrapper' style={{ maxWidth: '350px' }}>
                                        <img src='/images/others/ALEG-Image-Header_DashText.png' alt='airlegit-devices' />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='colored-container container-side-padding container-content-padding'>
                    <div className='container-small-width'>
                        <div className='container no-padding'>
                            <div className='row'>
                                <div className='col-md-12 text-med' style={{ textAlign: 'center' }}>
                                    Keep your client's employees aware with proactive flight disruption notifications. Keep them happy with automation remediation. Keep them loyal by protecting their peace of mind. All while saving your and your client's time and effort.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='content-container container-side-padding container-content-padding'>
                    <div className='container-small-width'>
                        <div className='container no-padding'>
                            <div className='row'>
                                <div className='col-md-6 order-2 order-md-1'>
                                    <h3 className='text-med'>
                                        AirLegit&#169; for Travel Management Companies
                                    </h3>
                                    <p className=''>
                                        AirLegit's flight disruption automation gives your and your business travelers unprecedented control over itineraries and game-changing tools for traveler support.
                                    </p>
                                    <p className=''>
                                        Quickly identify and respond to flight disruptions, provide timely, proactive updates to travelers, handle rebooking and claims behind the scenes to reduce customer support requests and provide higher quality services.
                                    </p>
                                    <p className='no-margin'>
                                        Minimize flight disruptions impact on your client and their travelers, simplify internal support operations, reduce your customer support overhead, and give your clients and their employees greater confidence in their travel itinerary.
                                    </p>
                                </div>
                                <div className='col-md-6 order-1 order-md-2'>
                                    <div className='bordered-img-wrapper'>
                                        <img src='/images/others/ALEG-Image-TravelManagement-Body_1.jpg' alt='frame' />
                                    </div>
                                </div>
                                <div className='col-md-6 order-3 small-screen-padding-top large-screen-padding-top'>
                                    <div className='bordered-img-wrapper left-img'>
                                        <img src='/images/others/ALEG-Image-TravelManagement-Body_2.jpg' alt='frame' />
                                    </div>
                                </div>
                                <div className='col-md-6 order-3 large-screen-padding-top'>
                                    <h3 className='text-med'>
                                        Travel Management Company Use Case
                                    </h3>
                                    <p className=''>
                                        A Corporate Travel Manager embedded FlightGuard48&#169;
                                        into every booking to ensure their key employees - surgeons receive actionable intelligence about their travel and get to their appointments.

                                    </p>
                                    <p className='no-margin'>
                                        From automated check-in to alternative flight arrangements to reassuring communications, FlightGuard48&#169; turns unanticipated disruptions into
                                        positive employee experiences.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <StartNow />
            </div>
            <Contact />
            <Footer />
        </>
    );
};

export default TMC;